module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Fc-Ge-Hc-Ia.6d6625e9.png";